import { ws } from '@/lib/wiservice';

// 1:1 wrapper around apiv2 `clinical_view.get_patient_file` (ACL_Session, POST).
// Session-authed like the dashboard view — straight to apiv2 via ws() (NOT WF50,
// which signs with the RSA key and holds no session). Params must already be
// apiv2-shaped (clinical_id_dev_user, clinical_tasks_limit). Throws WsError on a
// non-OK status — see services convention.
export interface ClinicalViewPatientFileBody {
  data?: Record<string, unknown>;
}

export async function getPatientFile(
  params: Record<string, unknown>,
): Promise<ClinicalViewPatientFileBody> {
  const res = await ws<ClinicalViewPatientFileBody>('clinical_view', 'get_patient_file', params);
  return res.body;
}
